import qrCodeViewer from './qr-code-viewer.component'

const module = angular.module('ac.components.qrcodeviewer', [])

module.component('qrCodeViewer', qrCodeViewer)

export default module.name
